import React from 'react';
import { styled, Tooltip } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import { Rating } from '@material-ui/lab';
import { BaseButton, BaseTypography } from '../../components/common';
import { openLoginModal } from 'src/store/layout/slice';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store';
import { useDialogWithData } from '../../utils/hooks/useDialogVisibility';
import { IShortInterview } from '../../api/base/Interviews/types';
import { USER_ROLES, USER_STATUS } from '../../utils/types/user';
import { useSnackbar } from 'notistack';
import { OverviewGuestModal } from '../../features/user/common/interviews/OverviewGuestModal';
import { ContactGuestModalContainer } from '../../features/landing/searchExpert/contactGuest/ContactGuestModalContainer';

const Card = styled('div')({
//   minWidth: '215px',
//   minHeight: '108px',
  width: '100%',
//   height: '108px',
  background: '#FFFFFF',
  boxShadow: '0px 8px 30px rgba(108, 108, 108, 0.15)',
  borderRadius: '4px',
  display: 'flex',
  gap: "20px",
  margin: "0 0 20px",
  padding: "0 20px"
});

const AvatarWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
});

const GuestInfoWrapper = styled('div')({
  width: '100%',
  display: 'grid',
  flexDirection: 'column',
  justifyContent: 'space-between',
  padding: '10px 10px 10px 0',
});

const StyledRating = styled(Rating)({
  fontSize: '14px',
});

interface IOwnProps {
  avatarSrc: string;
  fullName: string;
  guestId: number;
}

export const GuestDiscuss: React.FC<IOwnProps> = (props) => {
  const { avatarSrc, guestId, fullName } = props;
  const { user } = useSelector((state: RootState) => state.auth);
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();

  const {
    isOpened: shownGuestDetailsDialog,
    closeModal: closeGuestDetailsDialog,
    setData: setGuestDetails,
    data: guestDetailsData,
  } = useDialogWithData<IShortInterview>();

  const {
    isOpened: isContactGuestDialogOpened,
    closeModal: closeContactGuestDialog,
    setData: setContactGuestData,
    data: contactGuestId,
  } = useDialogWithData<string>();

  const handleShowGuestInfoBtnClick = () => {
    if (user) {
      setGuestDetails(guestId);
    } else {
      dispatch(openLoginModal("Journalist"));
    }
  };

  const handleDiscussBtnClick = (e: any) => {
    if (user) {
      if (user.role === USER_ROLES.JOURNALIST) {
        if (user.status === USER_STATUS.WAIT_FOR_APPROVING) {
          e.stopPropagation();
          enqueueSnackbar(
            'You can’t use any of the features until you have been approved. The approval process usually takes up to 24 hours.',
            {
              variant: 'warning',
            },
          );
        } else {
          setContactGuestData(guestId);
        }
      } else {
        enqueueSnackbar('Only journalist can create interviews', {
          variant: 'warning',
        });
      }
    } else {
      dispatch(openLoginModal("Journalist"));
    }
  };

  return (
    <Card>
      <AvatarWrapper>
        <Avatar onClick={handleShowGuestInfoBtnClick}
          style={{ width: '50px', height: '50px', marginBottom: '5px' }}
          alt={fullName}
          src={avatarSrc}
        />
      </AvatarWrapper>
      <GuestInfoWrapper>
        <BaseTypography
		onClick={handleShowGuestInfoBtnClick}
          variant="tag"
          gutterBottom="true"
          style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}>
          <Tooltip title={fullName} placement="top" arrow>
            <span>{fullName}</span>
          </Tooltip>
        </BaseTypography>
        <BaseTypography
          onClick={handleShowGuestInfoBtnClick}
          gutterBottom="true"
          variant="tag"
          className="pointer"
          style={{ fontSize: '12px', color: '#0090E5' }}>
          Detailed guest info
        </BaseTypography>
        <BaseButton
          onClick={handleShowGuestInfoBtnClick}
          style={{
            height: '32px',
            fontSize: '14px',
            padding: 0,
          }}>
          Invite Guest
        </BaseButton>
      </GuestInfoWrapper>

      {shownGuestDetailsDialog && (
        <OverviewGuestModal
          open={shownGuestDetailsDialog}
          onClose={closeGuestDetailsDialog}
          guestId={guestDetailsData}
        />
      )}

      {isContactGuestDialogOpened && (
        <ContactGuestModalContainer
          open={isContactGuestDialogOpened}
          onClose={closeContactGuestDialog}
          guestId={contactGuestId}
          onSuccess={() => {
            setContactGuestData();
          }}
        />
      )}
    </Card>
  );
};
